export default "__VITE_ASSET__tyPwfDnW__"